<template>
  <div>
    <template v-if="exportType === 'button'">
      <el-button
        type="primary"
        :size="formSize"
        @click="hancleExportReport()"
        :loading="isExportLoading"
        v-track
        :trackCode="trackCode"
      >
        {{buttonText}}
      </el-button>
    </template>
    <template v-else>
      <el-button
        type="primary"
        :size="formSize"
        @click="handleExport"
        :loading="isExportLoading"
        :disabled="total > limit || buttonLoadingText !== buttonText"
        v-track
        :trackCode="trackCode"
      >
        {{buttonLoadingText}}
      </el-button>
      <template v-if="total > limit">
        <el-tooltip class="item" effect="dark" content="最多只能导出20W，导出支持按筛选条件导出。若需导出超过20W以上数据，请联系开发人员" placement="top-start">
          <i class="el-icon-question"></i>
        </el-tooltip>
      </template>
    </template>

    <!-- 导出报表 -->
    <export-report-dialog
      :title="title"
      :visible.sync="isExportShow"
      :loading.sync="isExportLoading"
      @export-report="hancleExportReport"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <div
        slot="main"
        slot-scope="{data}"
      >
        <slot
          name="main"
          :data="data"
        />
      </div>
    </export-report-dialog>
  </div>
</template>

<script>
import exportReportDialog from './dialog';
import fileDownloadMixins from '@/mixins/file-download';
import { getAccount } from '@/utils/account';

export default {
  name: 'ExportButton',
  components: { exportReportDialog },
  mixins: [fileDownloadMixins],
  props: {
    // 请求url
    requestUrl: {
      type: String,
      default: '',
    },
    // 请求方式
    requestMethod: {
      type: String,
      default: 'post',
    },
    // 标题
    title: {
      type: String,
    },
    // 其他参数
    params: {
      type: Object,
    },
    // postData参数
    postParams: {
      type: Object,
    },
    // 自定义时间参数
    timeParams: {
      type: Object,
      default: () => ({
        beginTime: 'beginTime',
        endTime: 'endTime',
      }),
    },
    // 导出类型
    exportType: {
      type: String,
      default: 'default',
    },
    // 按钮文案
    buttonText: {
      type: String,
      default: '报表导出',
    },
    isLimit: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: 200000,
    },
    total: {
      type: Number,
      default: 0,
    },
    trackCode: {
      type: [String, Number],
    },
  },
  data() {
    return {
      isExportShow: false,
      isExportLoading: false,
      buttonLoadingText: this.buttonText,
    };
  },
  methods: {
    // 导出报表弹窗
    handleExport() {
      if (this.isLimit) {
        this.$confirm('是否确认导出？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          this.hancleExport(this.postParams);
        });
        return;
      }
      this.isExportShow = true;
    },
    hancleExportReport(param = {}, isCustom = false) {
      if (isCustom) {
        this.hancleExport(this.postParams);
        return;
      }
      const params = {
        ...this.params,
        [this.timeParams.beginTime]: param.beginTime,
        [this.timeParams.endTime]: param.endTime,
      };
      const postParams = {
        ...this.postParams,
        [this.timeParams.beginTime]: param.beginTime,
        [this.timeParams.endTime]: param.endTime,
      };
      const urlParams = this.postParams ? {} : params;
      const postParam = this.postParams ? postParams : params;
      this.hancleExport(postParam, urlParams);
    },

    async hancleExport(params = {}, urlParams = {}) {
      this.buttonLoadingText = '正在导出...';
      this.isExportShow = false;
      const account = getAccount();
      try {
        this.isExportLoading = true;
        const res = await this.exportByBlob({
          params: {
            ...urlParams,
            currentUserId: account ? account.id : '',
          },
          data: params,
          url: this.requestUrl,
          method: this.requestMethod,
        });
        this.isExportShow = false;
        if (res && res.staus === 200) {
          // 数据延迟处理，即接口返回200但文件流还没处理完成
          setTimeout(() => {
            this.buttonLoadingText = this.buttonText;
          }, 500);
        }
        this.$emit('close');
      } catch (error) {
        console.log(error);
        // this.$message.warning('导出失败，请重新导出！');
      } finally {
        this.isExportShow = false;
        this.isExportLoading = false;
        this.buttonLoadingText = this.buttonText;
      }
    },
  },
};
</script>
